import PageHeader from "@components/page_header"
import { PRIMARY } from "@constants/colors"
import { useCustomerPageContext } from "@contexts/customer"
import { Menu } from "@mui/icons-material"
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew"
import { IconButton, Stack, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import styles from "./styles"

export default function CustomerInfosPageHeader() {
  const { isLeftDrawerOpen, toggleIsLeftDrawerOpen, translate } =
    useCustomerPageContext()
  const navigate = useNavigate()

  const backToAllStatusClick = () => {
    navigate("/customers")
  }

  return (
    <PageHeader sx={styles.content} isLeftPanelOpen={isLeftDrawerOpen}>
      <Stack direction={"row"} alignItems={"center"} columnGap={1}>
        <IconButton
          onClick={toggleIsLeftDrawerOpen}
          disabled={isLeftDrawerOpen}
          disableRipple
          sx={{
            display: isLeftDrawerOpen ? "none" : "block",
            pl: 0,
            ":hover": {
              color: PRIMARY
            }
          }}
        >
          <Menu />
        </IconButton>
        <IconButton
          onClick={backToAllStatusClick}
          disableRipple
          sx={{
            pl: 0,
            ":hover": {
              color: PRIMARY
            }
          }}
        >
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>
        <Typography variant="h6">{translate("customers")}</Typography>
      </Stack>
    </PageHeader>
  )
}
